module.exports = "<div class=\"view-port\" style=\"\n    overflow: hidden;\n    display: inline-flex;\n    height: 100%;\n    width: 100%;\n    flex-direction: column;\n\">\n    <h3 class=\"module-header\" style=\"margin-top: 1rem; margin-left: 14px;\">\n        <span style=\"margin-left:8px;\">Network Extension</span>\n    </h3>\n    <iframe class=\"embedded-content-view\" name=\"extended-network-embed\"\n        [src]=\"iframeUrl\" frameborder=\"0\">\n    </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/network-extension2/network-extension-embed2.html
// module id = KCmS
// module chunks = 0